import TooltipWrapper from '../../../../client/components/Tooltip/TooltipWrapper'
import { useGetCart } from '../../../../client/components/CartQuery/CartQuery'
import React from 'react'

export const CartEditingDisabledTooltipWrapper = (
  props: React.PropsWithChildren<{}>
) => {
  const { isEditingDisabled } = useGetCart()

  return (
    <TooltipWrapper
      enableTooltip={isEditingDisabled}
      message={'Remove unavailable items to continue ordering'}
    >
      {props.children}
    </TooltipWrapper>
  )
}
